// Camada de serviço para MIT Apuração, delegando para a API centralizada
import api from './api'

export default {
  getPaginado(page, pageSize, filtros) {
    return api.getPaginado(page, pageSize, filtros)
  },
  getApuracaoMitEmpresa(empresasFiltro) {
    return api.getApuracaoMitEmpresa(empresasFiltro)
  },
  getApuracaoMitMesAno(empresasFiltro) {
    return api.getApuracaoMitMesAno(empresasFiltro)
  },
  getDebitosValores(pagina, tamanhoPagina, filtro) {
    return api.getDebitosValores(pagina, tamanhoPagina, filtro)
  },
  getDebitosEncerramento(pagina, tamanhoPagina, filtro) {
    return api.getDebitosEncerramento(pagina, tamanhoPagina, filtro)
  },
  getSuspensoes(pagina, tamanhoPagina, filtro) {
    return api.getSuspensoes(pagina, tamanhoPagina, filtro)
  },
}
